import {
  Currency,
  LaytimeCountingTrigger,
  PaymentTrigger,
  PaymentType,
  PaymentUnit,
} from '../graphql';

export const paymentUnitMap: Record<PaymentUnit, { label: string }> = {
  [PaymentUnit.MT]: { label: 'Per tonne' },
  [PaymentUnit.M3]: { label: 'Per cubic meter' },
  [PaymentUnit.FT3]: { label: 'Per cubic foot' },
  [PaymentUnit.SCBM_UB]: { label: 'Solid cubic meter under bark' },
  [PaymentUnit.BDMT]: { label: 'Bone dry metric tonne' },
  [PaymentUnit.LUMPSUM]: { label: 'Lumpsum' },
  [PaymentUnit.PER_PCS]: { label: 'Per pcs' },
  [PaymentUnit.PER_SET]: { label: 'Per set' },
  [PaymentUnit.WORLDSCALE]: { label: 'Worldscale' },
};

export const paymentUnits: Array<{ name: string; value: PaymentUnit }> =
  Object.entries(paymentUnitMap).map(([value, { label }]) => ({
    name: label,
    value: value as PaymentUnit,
  }));

export const currencies: Array<{
  name: string;
  id: Currency;
  value: Currency;
}> = [
  {
    name: '€ Euro',
    id: Currency.EUR,
    value: Currency.EUR,
  },
  {
    name: '$ US Dollars',
    id: Currency.USD,
    value: Currency.USD,
  },
  {
    name: 'SEK kr Swedish krona',
    id: Currency.SEK,
    value: Currency.SEK,
  },
  {
    name: 'NOK kr Norwegian krone',
    id: Currency.NOK,
    value: Currency.NOK,
  },
  {
    name: 'DKK kr. Danish Krone',
    id: Currency.DKK,
    value: Currency.DKK,
  },
  {
    name: '£ British Pound',
    id: Currency.GBP,
    value: Currency.GBP,
  },
  {
    name: '¥ Japanese Yen',
    id: Currency.JPY,
    value: Currency.JPY,
  },
  {
    name: '₩ Korean won',
    id: Currency.KRW,
    value: Currency.KRW,
  },
  {
    name: 'A$ Australian Dollar',
    id: Currency.AUD,
    value: Currency.AUD,
  },
  {
    name: 'C$ Canadian Dollar ',
    id: Currency.CAD,
    value: Currency.CAD,
  },
  {
    name: '$ New Zealand Dollar',
    id: Currency.NZD,
    value: Currency.NZD,
  },
  {
    name: 'NT$ Taiwan dollar',
    id: Currency.TWD,
    value: Currency.TWD,
  },
  {
    name: 'R$ Brazilian Real',
    id: Currency.BRL,
    value: Currency.BRL,
  },
  {
    name: 'BZ$ Belize Dollar',
    id: Currency.BZD,
    value: Currency.BZD,
  },
  {
    name: '¥ Chinese Yuan',
    id: Currency.CNY,
    value: Currency.CNY,
  },
  {
    name: '₹ Indian Rupee',
    id: Currency.INR,
    value: Currency.INR,
  },
  {
    name: 'kr Icelandic Króna',
    id: Currency.ISK,
    value: Currency.ISK,
  },
  {
    name: 'د.م. Moroccan Dirham',
    id: Currency.MAD,
    value: Currency.MAD,
  },
  {
    name: '$ Mexican Peso',
    id: Currency.MXN,
    value: Currency.MXN,
  },
  {
    name: 'RM Malaysian Ringgit',
    id: Currency.MYR,
    value: Currency.MYR,
  },
  {
    name: 'N$ Namibian Dollar',
    id: Currency.NAD,
    value: Currency.NAD,
  },
  {
    name: 'zł Polish Złoty',
    id: Currency.PLN,
    value: Currency.PLN,
  },
  {
    name: '₽ Russian Ruble',
    id: Currency.RUB,
    value: Currency.RUB,
  },
  {
    name: 'S$ Singapore Dollar',
    id: Currency.SGD,
    value: Currency.SGD,
  },
  {
    name: 'د.ت Tunisian Dinar',
    id: Currency.TND,
    value: Currency.TND,
  },
  {
    name: 'CFA CFA Franc BCEAO',
    id: Currency.XOF,
    value: Currency.XOF,
  },
  {
    name: 'R South African Rand',
    id: Currency.ZAR,
    value: Currency.ZAR,
  },
  {
    name: '$ Chilean Peso',
    id: Currency.CLP,
    value: Currency.CLP,
  },
];

export const paymentTriggers: Array<{ name: string; value: PaymentTrigger }> = [
  {
    name: 'upon s/r BoL',
    value: PaymentTrigger.UPON_S_R_BO_L,
  },
  {
    name: 'after right and true delivery',
    value: PaymentTrigger.AFTER_RIGHT_AND_TRUE_DELIVERY,
  },
  {
    name: 'invoice date',
    value: PaymentTrigger.INVOICE_DATE,
  },
  {
    name: 'after measurement',
    value: PaymentTrigger.AFTER_MEASUREMENT,
  },
];

export const paymentTypes: Array<{ name: string; value: PaymentType }> = [
  {
    name: 'On delivery',
    value: PaymentType.ON_DELIVERY,
  },
  {
    name: 'Prepaid',
    value: PaymentType.PREPAID,
  },
];

export const laytimeCountingTriggers: Array<{
  name: string;
  value: LaytimeCountingTrigger;
}> = [
  {
    name: 'Arrival at pilot boarding station',
    value: LaytimeCountingTrigger.ARRIVAL_AT_PILOT_BOARDING_STATION,
  },
  {
    name: 'NOR tendered',
    value: LaytimeCountingTrigger.NOR_TENDERED,
  },
  {
    name: 'Berthing',
    value: LaytimeCountingTrigger.BERTHING,
  },
];
